module.exports = __webpack_public_path__ + "static/img/banner-7.f0da40db.png";